/**
 * Longest topic query a LinkedIn post source can store. It mirrors the column
 * `li_post.query` (`DataType.STRING(255)` in `apps/api/src/li-post/models/li-post.model.ts`) — a
 * longer query is refused by MySQL with "Data too long for column 'query'", so the API DTO and the
 * web form both refuse it at entry instead.
 */
export const LI_POST_QUERY_MAX_LENGTH = 255;
